// src/components/landing/Navbar.jsx
import { useState } from "react";
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link } from "react-router-dom";
import logo from "./assets/logo1.svg";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const navItems = [
        { label: 'About', href: '#about' },
        { label: 'Features', href: '#features' },
        { label: 'Pages', href: '#', hasDropdown: true },
        { label: 'Integrations', to: '/integrations' },
        { label: 'Pricing', href: '#pricing' },
        { label: 'Blog', href: '#blog' },
    ];

    // Keep smooth scrolling behavior for internal section links.
    const handleScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
        setIsOpen(false);
    };

    const handleNavClick = (event, href) => {
        if (!href || href === '#') {
            event.preventDefault();
            return;
        }

        if (href.startsWith('#')) {
            event.preventDefault();
            handleScroll(href.slice(1));
        }
    };

    return (
        <header className="w-full bg-white border-b border-stone-200">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between relative">
                {/* Left: Logo */}
                <div className="flex items-center">
                    <img src={logo} alt="Kaeros" className="h-7 w-auto" />
                </div>

                {/* Center: Navigation Links (Desktop) */}
                <nav className="hidden md:flex items-center gap-5 lg:gap-7 text-sm lg:text-[15px] text-stone-800 font-medium absolute left-1/2 -translate-x-1/2">
                    {navItems.map((item) => (
                        item.to ? (
                            <Link
                                key={item.label}
                                to={item.to}
                                className="inline-flex items-center gap-1 hover:text-black transition-colors"
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <a
                                key={item.label}
                                href={item.href}
                                className="inline-flex items-center gap-1 hover:text-black transition-colors"
                                onClick={(event) => handleNavClick(event, item.href)}
                            >
                                {item.label}
                                {item.hasDropdown ? <ChevronDown className="w-4 h-4" /> : null}
                            </a>
                        )
                    ))}
                </nav>

                {/* Right: Contact CTA (Desktop/Tablet) */}
                <div className="hidden md:flex items-center">
                    <a href="#contact" className="text-[15px] font-semibold text-[#141414] hover:text-black transition-colors">
                        Contact us
                    </a>
                </div>

                {/* Hamburger Menu Button (Mobile) */}
                <button className="md:hidden text-gray-800 focus:outline-none" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden border-t border-stone-200 px-4 sm:px-6 pb-5 pt-4 space-y-3 text-stone-800">
                    {navItems.map((item) => (
                        item.to ? (
                            <Link
                                key={item.label}
                                to={item.to}
                                className="flex items-center justify-between py-1 hover:text-black"
                                onClick={() => setIsOpen(false)}
                            >
                                <span>{item.label}</span>
                            </Link>
                        ) : (
                            <a
                                key={item.label}
                                href={item.href}
                                className="flex items-center justify-between py-1 hover:text-black"
                                onClick={(event) => handleNavClick(event, item.href)}
                            >
                                <span>{item.label}</span>
                                {item.hasDropdown ? <ChevronDown className="w-4 h-4" /> : null}
                            </a>
                        )
                    ))}
                    <a
                        href="#contact"
                        className="block pt-2 font-semibold text-[#141414]"
                        onClick={(event) => handleNavClick(event, '#contact')}
                    >
                        Contact us
                    </a>
                    <div className="pt-1">
                        <Link
                            to="/signup"
                            className="inline-flex items-center justify-center bg-[#171717] text-white px-4 py-2 rounded-md text-sm font-medium"
                            onClick={() => setIsOpen(false)}
                        >
                            Try For Free
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
